import { render, staticRenderFns } from "./DialogNewSchedule.vue?vue&type=template&id=8cd54488"
import script from "./DialogNewSchedule.vue?vue&type=script&lang=js"
export * from "./DialogNewSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports